module.exports = __webpack_public_path__ + "media/images/payment/jcb-3d7ef2d3a493653673cc102b0969cd17.svg";